/*
 * 戒导航 · 统一审核中心（jiedh/review）前台 JS 总出口
 *
 * 设计依据：doc/统一审核中心设计方案.md §5.14「处置回执中心」。
 *
 * 运行范围：论坛前台（SPA）。后台另有独立入口 js/admin.ts，两者互不干扰。
 *
 * ⚠️ 关键：Flarum 的 Application::bootExtensions() 只读取扩展模块的 `extend` 键，
 * 所以这里必须写 `export { default as extend } from './extend';`，而不是默认导出。
 */
import app from 'flarum/forum/app';

// 扩展声明：注册处置回执通知卡片（见 ./extend.ts）
export { default as extend } from './extend';
app.initializers.add('jiedh-review', () => {
  // 本模块前台无需额外初始化动作：
  //   - 通知组件通过 Extend.Notification().add() 注册（见 ./extend.ts）；
  //   - 点击通知的跳转、原因展示全部在组件内完成。
});